import { render, staticRenderFns } from "./index.vue?vue&type=template&id=390ebee9&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390ebee9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/app/jenkins/data/workspace/TEST测试环境/xcommunity-test/syx-web-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('390ebee9')) {
      api.createRecord('390ebee9', component.options)
    } else {
      api.reload('390ebee9', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=390ebee9&scoped=true", function () {
      api.rerender('390ebee9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DYImage/index.vue"
export default component.exports